import { render } from "./profile-page.vue?vue&type=template&id=3bae1c1c&scoped=true"
import script from "./profile-page.vue?vue&type=script&lang=js"
export * from "./profile-page.vue?vue&type=script&lang=js"

import "./profile-page.vue?vue&type=style&index=0&id=3bae1c1c&scoped=true&lang=css"

import exportComponent from "/var/www/tap-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bae1c1c"]])

export default __exports__